import { Component, OnInit } from '@angular/core';
import Slideout from 'slideout';

@Component({
	selector: 'app-guest-sidebar',
	templateUrl: './guest-sidebar.component.html',
	styleUrls: ['./guest-sidebar.component.scss'],
})
export class GuestSidebarComponent implements OnInit {
	public navSlideout;

	get loginLink(): string {
		return '/login';
	}

	get registerLink(): string {
		return '/signup';
	}

	ngOnInit(): void {
		this.createSlideout();
	}

	toggleButtonClass() {
		const toggleButton = document.querySelector('.toggle-button');
		if (toggleButton.getAttribute('class').indexOf('nav-open') === -1) {
			toggleButton.classList.add('nav-open');
		} else {
			toggleButton.classList.remove('nav-open');
		}
		this.navSlideout.toggle();
	}

	onLinkClick() {
		this.toggleButtonClass();
		this.navSlideout.close();
	}

	createSlideout() {
		this.navSlideout = new Slideout({
			panel: document.getElementById('slider-panel-features'),
			menu: document.getElementById('slider-menu'),
			// eslint-disable-next-line no-restricted-globals
			padding: screen.width,
		});

		document.querySelector('.toggle-button').addEventListener('click', () => this.toggleButtonClass());
	}
}
